import { useState, useRef } from "react";
import { IonPage, IonContent, IonButton } from "@ionic/react";
import {
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { baseUrl, config, requestID } from "../../common/utils";
import axios from "axios";
import { get, set } from "react-hook-form";
import { useHistory } from "react-router";

const BusinessSetup: React.FC = () => {
  const [businessType, setBusinessType] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    phone: "",
    email: "",
    businessTypeId: "",
    targetedSavings: "",
    collectionAmount: "",
    cycleDays: "",
    size: "",
    requestID: requestID(),
  });
  const [message, setMessage] = useState<string | null>(null);
  const [showPopover, setShowPopover] = useState<{
    showPopover: boolean;
    event: Event | undefined;
  }>({
    showPopover: false,
    event: undefined,
  });
  const history = useHistory();
  const parag = useRef<HTMLParagraphElement | null>(null);

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>
  ) => {
    setFormData({
      ...formData,
      [event.target.name as string]: event.target.value,
    });
  };

  // .post(baseUrl() + url, {
  //   username: email_x,
  //   password: password_x,
  //   requestID: requestID(),
  // })

  const getAllloans = () => {
    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("address", formData.address);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("businessTypeId", formData.businessTypeId);
    formDataToSend.append("targetedSavings", formData.targetedSavings);
    formDataToSend.append("collectionAmount", formData.collectionAmount);
    formDataToSend.append("cycleDays", formData.cycleDays);
    formDataToSend.append("size", formData.size);
    formDataToSend.append("requestID", requestID());

    console.log("Form Data:", formDataToSend);

    if (
      formData.businessTypeId === "1002" ||
      formData.businessTypeId === "1003"
    ) {
      formDataToSend.append("targetedSavings", formData.targetedSavings);
      formDataToSend.append("collectionAmount", formData.collectionAmount);
      formDataToSend.append("cycleDays", formData.cycleDays);
      formDataToSend.append("size", formData.size);
    }

    if (
      !formData.name ||
      !formData.address ||
      !formData.phone ||
      !formData.email ||
      !formData.businessTypeId
    ) {
      setMessage("All fields are required");
      parag.current.style.display = "block";
      parag.current.style.color = "red";
      setShowPopover({ showPopover: true, event: undefined });
      return;
    }

    axios
      .post(baseUrl() + "businesss/addbusiness", formData, config)
      .then((response) => {
        console.log({ response });

        console.log(response.data.data);
        setMessage("Business Created Successfully");
        setShowPopover({ showPopover: true, event: undefined });
        setTimeout(
          () => setShowPopover({ showPopover: false, event: undefined }),
          3000
        );
        history.push("/folder/BusinessPage");
        // window.location.replace("/folder/BusinessPage");
      })
      .catch((error) => {
        // setStatus({ loading: false, error: false });
        // throw new error("hey ");
        console.log(error);
        console.error("Error creating business:", error);
        setMessage("Error creating business");
        setShowPopover({ showPopover: true, event: undefined });
      });
  };
  // const API_BASE_URL = "https://beninclubgolfapi.kademic5.com.ng/";
  //users/loginfunc
  const handleSubmit = async () => {
    console.log("Form Data:", formData);
    try {
      // const response = await axios.post(`${baseUrl()}businesss/addBusiness`, formData,config);
      // const response = await axios.post(`${API_BASE_URL}mybusiness/addbusiness`, formData, config);
      const response = await axios.post(
        baseUrl() + "businesss/addbusiness",
        formData,
        config
      );
      // const response = await axios.post(baseUrl() + "applyloans/getAlloans", formData, config);
      console.log("Business Created:", response);
      // console.log("Business Created:", response.data;
      setMessage("Business Created Successfully");
      setShowPopover({ showPopover: true, event: undefined });
      // history.push("/folder/inbox");
      //     window.location.replace("/folder/inbox");
    } catch (error) {
      console.error("Error creating business:", error);
      setMessage("Error creating business");
      setShowPopover({ showPopover: true, event: undefined });
    }
  };

  return (
    <IonPage>
      <IonContent className="ion-padding">
        <h2>Set Up Your Business</h2>
        <TextField
          label="Business Name"
          name="name"
          fullWidth
          margin="normal"
          onChange={handleChange}
        />
        <TextField
          label="Address"
          name="address"
          fullWidth
          margin="normal"
          onChange={handleChange}
        />
        <TextField
          label="Phone"
          name="phone"
          fullWidth
          margin="normal"
          onChange={handleChange}
        />
        <TextField
          label="Email"
          name="email"
          fullWidth
          margin="normal"
          onChange={handleChange}
        />

        <FormControl fullWidth margin="normal">
          <InputLabel>Business Type</InputLabel>
          <Select
            label="Business  Type"
            value={businessType}
            onChange={(event) => {
              setBusinessType(event.target.value as string);
              setFormData({
                ...formData,
                businessTypeId: event.target.value as string,
              });
            }}
          >
            <MenuItem value="1001">COOPERATIVE</MenuItem>
            <MenuItem value="1004">MEMBERS CLUB</MenuItem>
            <MenuItem value="1005">ACCOUNTING</MenuItem>
            <MenuItem value="1007">HUMAN RESOURCE MANAGEMENT (HR)</MenuItem>
            <MenuItem value="1009">SALES APP</MenuItem>
            <MenuItem value="1010">HR CONSULTING BUSINESS</MenuItem>
            <MenuItem value="1011">SABI SHARE APP</MenuItem>
            <MenuItem value="1012">ARTISAN SERVICES APP</MenuItem>
            <MenuItem value="1014">HOTEL MANAGEMENT SYSTEM</MenuItem>
            <MenuItem value="1015">Gea-Cloud Accounting</MenuItem>
            <MenuItem value="1006">Computer Based Test (CBT) App</MenuItem>

            {/*  <MenuItem value="1002">AJO</MenuItem>
            <MenuItem value="1003">CHRISTMAS SAVINGS</MenuItem> */}
          </Select>
        </FormControl>

        {(businessType === "1002" || businessType === "1003") && (
          <>
            <TextField
              label="Targeted Savings Amount"
              name="targetedSavings"
              fullWidth
              margin="normal"
              onChange={handleChange}
            />
            <TextField
              label="Collection Total Amount"
              name="collectionAmount"
              fullWidth
              margin="normal"
              onChange={handleChange}
            />
            <TextField
              label="Cycle Days"
              name="cycleDays"
              fullWidth
              margin="normal"
              onChange={handleChange}
            />
            <TextField
              label="Size"
              name="size"
              fullWidth
              margin="normal"
              onChange={handleChange}
            />
          </>
        )}
        {showPopover && <p className="popover">{message}</p>}

        {/* <IonButton expand="full" onClick={handleSubmit}>Submit</IonButton> */}
        <IonButton expand="full" onClick={getAllloans}>
          Submit
        </IonButton>
      </IonContent>
    </IonPage>
  );
};

export default BusinessSetup;
